import { Component, OnInit, ViewChild } from '@angular/core';
import { ExtrasModel } from '../../models/extra/extras.model';

import { MatDialog} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';

import { ExtraService } from '../../services/extra.service';
import { ExtrasDialogComponent } from '../extras-dialog/extras-dialog.component';
import { ExtrasImprimirDialogComponent } from '../extras-imprimir-dialog/extras-imprimir-dialog.component';

@Component({
  selector: 'app-extras',
  templateUrl: './extras.component.html',
  styleUrls: ['./extras.component.css']
})
export class ExtrasComponent implements OnInit {
  extrasmodel: ExtrasModel;
  displayedColumns: string[] = [];
  datasource: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  tabla: any[];

  constructor(private extraservice: ExtraService,
              private dialog: MatDialog,
              public paginatorInt: MatPaginatorIntl) { }

  ngOnInit(): void {
            this.extrasmodel = new ExtrasModel();
            this.extrasmodel.idextra = 0;
            this.extrasmodel.idsucursal = Number(sessionStorage.ids);
            this.extrasmodel.idrol = Number(sessionStorage.idr);

            // if (validaacceso(Number(sessionStorage.idr))) {
            //   console.log('acceso correcto');
            // } else {

            //   Swal.fire({
            //     position: 'center',
            //     icon: 'warning',
            //     title: '¡Acceso no permitido!',
            //     showConfirmButton: true,
            //     timer: 7500
            //   });

            //   // console.log('acceso no permitido');
            //   return;
            // }

            // function validaacceso(rol: number) {
            //   let acceso = false;
            //   switch (rol) {
            //     case 1:
            //       acceso = true; // Super Admin
            //       break;
            //     case 2:
            //       acceso = true; // Administrador (Tienda)
            //       break;
            //     case 3:
            //       acceso = true; // Administrador (Sucursal)
            //       break;
            //     case 4:
            //       acceso = true; // Empleado
            //       break;
            //     case 5:
            //       acceso = false; // Cliente
            //       break;
            //     case 6:
            //       acceso = false; // Repartidor
            //       break;
            //     // default:
            //     //   this.router.navigateByUrl('/');
            //     //   break;
            //   }
            //   return acceso;
            // }

            this.getGridExtras();

            this.paginatorInt.firstPageLabel = 'Primera página';
            this.paginatorInt.lastPageLabel = 'Última página';
            this.paginatorInt.itemsPerPageLabel = 'Registro por página';
            this.paginatorInt.nextPageLabel     = 'Siguiente página';
            this.paginatorInt.previousPageLabel = 'Anterior página';
  }

  reloadgrid() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.getGridExtras();
    Swal.close();
  }

  acceso(row) {
    this.openDialogExtras(row);
  }

  getGridExtras() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.displayedColumns = ['idextra', 'estaActivo', 'extra', 'precio', 'requiereDist', 'sucursal', 'actions'];
    this.extraservice.getCatExtrasGrid(this.extrasmodel.idsucursal, this.extrasmodel.idrol).subscribe( (resp: any[]) => {
          Swal.close();
          this.dataSource = new MatTableDataSource<any>(resp);
          this.tabla = resp;
          this.dataSource.paginator = this.paginator;
    }, (err) => {
      Swal.close();
      switch (err.status) {
      case 0:
          Swal.fire({
            icon: 'warning',
            text: 'No hay conexión con el servidor'
          });
          break;
       case 409:
         Swal.fire({
          icon: 'error',
          text: 'Error ' + err.status + ' para el grid de extras en el servidor'
         });
         break;
        case 500:
            Swal.fire({
              icon: 'error',
              text: 'Error ' + err.status + ' para el grid de extras en el servidor'
            });
            break;

      }
    });
  }

  openDialogExtras(rows: any): void {
    if ( rows === undefined ) {
      const dialogRef = this.dialog.open( ExtrasDialogComponent , {

        data: {titulo: 'Agregar el extra',
          row: '',
        },
        disableClose: true,
        height: String(screen.height * 0.90),
        width: String(screen.width * 0.80),
        panelClass: 'full-screen-modal'
      });
      dialogRef.afterClosed().subscribe(result => {
       this.getGridExtras();
      });
    } else {
      const dialogRef = this.dialog.open( ExtrasDialogComponent , {
        data: {titulo: 'Modificar el extra',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.80),
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getGridExtras();
      });
    }
  }

  openDialogImprimir(rows): void {
    // if ( rows === undefined ) {
      const dialogRef = this.dialog.open( ExtrasImprimirDialogComponent, {
        data: {titulo: 'Vista previa',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.90),
      });
      dialogRef.afterClosed().subscribe(result => {
       // this.getGridSucursal();
      });
    // }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tablaFilter(filterValue.trim().toLowerCase());
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  tablaFilter(cadena: string) {

    // llenar la tabla para el reporte
    // const cadena = filterValue.trim().toLowerCase();
    const tablatemp = [];
    for (let i=0; i < this.tabla.length; i++) {
      if (this.tabla[i].extra.trim().toLowerCase().indexOf(cadena) > -1 || 
          this.tabla[i].precio.toString().trim().toLowerCase().indexOf(cadena) > -1 || 
          this.tabla[i].sucursal.trim().toLowerCase().indexOf(cadena) > -1 
         ) {
        tablatemp.push(this.tabla[i]);
      }
    }
    this.tabla = [];
    this.tabla = tablatemp;
    console.log(tablatemp);
  }


  UpdBajaExtra(UsuarioRow: any) {
    this.bajaExtra(UsuarioRow);
  }

  bajaExtra(row: any) {

    const username = row.extra;

    // operacion
    // 1. insertar
    // 2. actualizar
    // 3. dar de baja
    // 4. restaurar usuario

    row.operacion = 3;
    // console.log(row);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn ',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: true,
      confirmButtonColor: '#391410',
      cancelButtonColor: '#d01d17',
      confirmButtonText: 'Aceptar'
    } );

    swalWithBootstrapButtons.fire({
      title: '¿Dar de baja ' + username + '?',
      text: 'Confirme por favor',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {

          this.extraservice.abcCatExtras(row).subscribe( (resp: any[]) => {
          Swal.close();

          // Swal.fire({
          //   icon: 'success',
          //   text: 'El extra ' + username + ' ha sido dado de baja.'
          // });

          // si regresa respuesta el servicio
          if (resp) {

            if (resp['idrespuesta'] > 0) {
              Swal.fire({
                icon: 'success',
                text: resp['respuesta']
              });
              this.getGridExtras();
              } else {
              Swal.fire({
                icon: 'error',
                text: resp['respuesta']
              });
              }
          }
          }, (err) => {
            switch (err.status) {
            case 0:
                Swal.fire({
                  icon: 'warning',
                  text: 'No hay conexión con el servidor'
                });
                break;
              case 409:
                Swal.fire({
                icon: 'error',
                text: 'Error ' + err.status + ' en el guardado del panel de extras'
                });
                break;
              case 500:
                  Swal.fire({
                    icon: 'error',
                    text: 'Error ' + err.status + ' en el guardado del panel de extras'
                  });
                  break;
            }
          });

          swalWithBootstrapButtons.fire(
            'Atencion!',
            'El extra ' + username + ' ha sido dado de baja.',
            'success'
          );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelar',
          'La baja no fue realizada!',
          'warning'
        );
      }
    });

  }

  updRestaurarExtra(row: any) {

    this.restaurarExtra(row);

  }

  restaurarExtra(row: any) {

    const username = row.extra;

    // operacion
    // 1. insertar
    // 2. actualizar
    // 3. dar de baja
    // 4. restaurar usuario

    row.operacion = 4;
    // console.log(row);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn ',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: true,
      confirmButtonColor: '#391410',
      cancelButtonColor: '#d01d17',
      confirmButtonText: 'Aceptar'
    } );

    swalWithBootstrapButtons.fire({
      title: '¿Restaurar ' + username + '?',
      text: 'Confirme por favor',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {

          this.extraservice.abcCatExtras(row).subscribe( (resp: any[]) => {
          Swal.close();

          Swal.fire({
            icon: 'success',
            text: 'El extra ' + username + ' ha sido restaurado.'
          });

          // si regresa respuesta el servicio
          // if (resp) {

          //   if (resp['idrespuesta'] > 0) {
          //     Swal.fire({
          //       icon: 'success',
          //       text: resp['respuesta']
          //     });
          //     this.getGridExtras();
          //     } else {
          //     Swal.fire({
          //       icon: 'error',
          //       text: resp['respuesta']
          //     });
          //     }
          // }
          }, (err) => {
            switch (err.status) {
            case 0:
                Swal.fire({
                  icon: 'warning',
                  text: 'No hay conexión con el servidor'
                });
                break;
              case 409:
                Swal.fire({
                icon: 'error',
                text: 'Error ' + err.status + ' en el guardado del panel de extras'
                });
                break;
              case 500:
                  Swal.fire({
                    icon: 'error',
                    text: 'Error ' + err.status + ' en el guardado del panel de extras'
                  });
                  break;
            }
          });

          swalWithBootstrapButtons.fire(
            'Atencion!',
            'El extra ' + username + ' ha sido restaurado.',
            'success'
          );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelar',
          'La restauración del extra no fue realizada!',
          'warning'
        );
      }
    });

  }

}
